import { useQuery } from '@apollo/client';
import { isLoggedInQuery } from '../apollo/cache/localQuery';

const useIsLogged = () => {
  const { data: { isLoggedIn: isLogged } } = useQuery(isLoggedInQuery);
  return isLogged;
};

export default useIsLogged;
